// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"ITfvZRxbeI5TDAhnivCA","button":"ZTOK3IVluWjsp_y2AiXA"};